import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ShieldIcon from '@mui/icons-material/Shield';
import { PageHeader } from '../../components/ui/PageHeader';
import { getPageSubtitle } from '../../constants/pageSubtitles';
import { superAdminAPI } from '../../services/api';
import { SuperAdminDataTable, apiErrorMessage, statusChip, STATUS_FILTER_OPTIONS } from '../../components/superadmin/SuperAdminDataTable';

export const SuperAdminUsersPage: React.FC = () => {
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    superAdminAPI.getSuperAdminUsers()
      .then((r) => setUsers(r.data))
      .catch((err) => setError(apiErrorMessage(err, 'Failed to load users')))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box>
      <PageHeader title="Super Admin Users" subtitle={getPageSubtitle('super_admin_users')}
        icon={<ShieldIcon />}
 />
      <SuperAdminDataTable
        rows={users}
        loading={loading}
        error={error}
        exportFileName="super-admin-users"
        exportSheetName="Users"
        statusField="status"
        searchPlaceholder="Search name or email..."
        columns={[
          {
            id: 'name',
            header: 'Name',
            searchValue: (u) => u.name,
            exportValue: (u) => u.name,
            render: (u) => <strong>{u.name}</strong>,
          },
          {
            id: 'email',
            header: 'Email',
            searchValue: (u) => u.email,
            exportValue: (u) => u.email,
            render: (u) => u.email,
          },
          {
            id: 'role',
            header: 'Role',
            searchValue: (u) => u.roleType,
            exportValue: (u) => u.roleType,
            render: (u) => u.roleType?.replace('_', ' '),
          },
          {
            id: 'status',
            header: 'Status',
            exportValue: (u) => u.status,
            filterType: 'select',
            filterOptions: STATUS_FILTER_OPTIONS,
            filterValue: (u) => u.status,
            render: (u) => statusChip(u.status),
          },
        ]}
      />
    </Box>
  );
};
